export default __webpack_public_path__ + "static/media/wallet.911a2f9e.jpg";